import config from '../config'
import APIService from '../APIService'

export default {
    fetchById: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/${id}`,
            method: 'GET',
        })
    },
    getAll: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/all/${id}`,
            method: 'GET',
        })
    },
    create: (data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin`,
            method: 'POST',
            data
        })
    },
    bulkUserCreate: (data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/bulk`,
            method: 'POST',
            data
        })
    },
    update: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/${id}`,
            method: 'PATCH',
            data
        })
    },
    updateSettings: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/settings/${id}`,
            method: 'PATCH',
            data
        })
    },
    delete: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/${id}`,
            method: 'DELETE',
            data
        })
    },
    getContracts: (id, contractId) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/dynamicCombo/contracts/${id}/${contractId ? contractId : ''}`,
            method: 'GET',
        })
    },
    getDefaultAuthenticationType: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/getDefaultAuthenticationType/${id}`,
            method: 'GET',
        })
    },
    getOffices: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/dynamicCombo/offices/${id}`,
            method: 'GET',
        })
    },
    getTeams: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/useradmin/dynamicCombo/teams/${id}`,
            method: 'GET',
        })
    },
    getContractType(){
        return APIService.fetch({
            url: `${config.api.url}/api/v1/contractadmin/dynamicCombo/contractTypes`,
            method: 'GET',
        })
    }
}